import type { DefectCatalogItem } from '../contracts/availableLayers';

import { getLineConditionCatalogDefects } from './lineConditionCatalog';

export function mergeLineConditionCatalogDefects(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  const surveyTypeFilters = (surveyTypes ?? [])
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  const lineConditionDefects =
    surveyTypeFilters.length === 0
      ? getLineConditionCatalogDefects()
      : getLineConditionCatalogDefects().filter((defect) =>
          surveyTypeFilters.includes(defect.surveyType.trim().toLowerCase()),
        );

  if (lineConditionDefects.length === 0) {
    return defects;
  }

  const bySlug = new Map<string, DefectCatalogItem>();
  for (const defect of defects) {
    bySlug.set(String(defect.slug), defect);
  }
  for (const lineCondition of lineConditionDefects) {
    bySlug.set(String(lineCondition.slug), lineCondition);
  }
  return Array.from(bySlug.values());
}
